var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"twobox"},_vm._l((_vm.itemlist),function(item,index){return _c('itembox',{key:index,attrs:{"info":item},on:{"icon":_vm.icon}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }